export default __webpack_public_path__ + "static/media/10.871017b3.mp3";